export default {
  'pages.covenantDevice.mac': 'Adreça MAC',
  'pages.admin.providerCard.config.grpcAddr': 'Adreça gRPC',
  'pages.covenantDevice.cardTitle': 'Gestió de dispositius contractuels',
  'pages.admin.whitelist.mac': 'Adreça MAC',
  'pages.covenantDevice.operations': 'Operacions',
  'pages.covenantDevice.expireTime': 'Data de caducitat',
  'pages.covenantDevice.updateTime': 'Hora d\'actualització',
  'pages.admin.devices': 'Gestió de dispositius',
  'pages.admin.unbindDevice': 'Desvinculació de dispositius',
  'pages.unbindDevice.titleAdmin': 'Desvinculació de dispositius (requereix permisos d\'administrador)',
  'pages.unbindDevice.inputPlaceholder': 'Introduïu l\'ID del dispositiu',
  'pages.unbindDevice.unbind': 'Desvincular',
  'pages.unbindDevice.unbinding': 'Desvinculant...',
  'pages.unbindDevice.success': 'Desvinculació exitosa',
  'pages.unbindDevice.fail': 'Desvinculació fallida',
  'pages.layouts.userLayout.title':'Consola de gestió',
  'pages.login.accountLogin.tab': 'Inici de sessió amb compte i contrasenya',
  'pages.login.accountLogin.errorMessage':'Nom d\'usuari i contrasenya incorrectes',
  'pages.register': 'Registre d\'usuari nou',
  'pages.login.failure': 'Inici de sessió fallit, torneu-ho a provar!',
  'pages.login.success': 'Inici de sessió exitós!',
  'pages.login.username.placeholder': 'Nom d\'usuari',
  'pages.login.username.required': 'El nom d\'usuari és obligatori!',
  'pages.login.password.placeholder': 'Contrasenya',
  'pages.login.password.required': 'La contrasenya és obligatòria!',
  'pages.login.phoneLogin.tab': 'Inici de sessió amb telèfon',
  'pages.login.phoneLogin.errorMessage': 'Codi de verificació incorrecte',
  'pages.login.phoneNumber.placeholder': 'Introduïu el número de telèfon!',
  'pages.login.phoneNumber.required': 'El número de telèfon és obligatori!',
  'pages.login.phoneNumber.invalid': 'Número de telèfon no vàlid!',
  'pages.login.captcha.placeholder': 'Introduïu el codi de verificació!',
  'pages.login.captcha.required': 'El codi de verificació és obligatori!',
  'pages.login.phoneLogin.getVerificationCode': 'Obtenir codi de verificació',
  'pages.getCaptchaSecondText': 'segons abans de tornar a obtenir',
  'pages.login.rememberMe': 'Inici de sessió automàtic',
  'pages.login.forgotPassword': 'Heu oblidat la contrasenya?',
  'pages.login.submit': 'Iniciar sessió',
  'pages.login.loginWith': 'Altres maneres d\'iniciar sessió:',
  'pages.login.registerAccount': 'Registrar compte',
  'pages.welcome.link': 'Benvingut',
  'pages.welcome.alertMessage': 'Components pesats més ràpids i potents, ja publicats.',
  'pages.404.subTitle': 'Ho sentim, la pàgina que voleu visitar no existeix.',
  'pages.404.buttonText': 'Tornar a l\'inici',
  'pages.admin.subPage.title': ' Aquesta pàgina només es pot veure amb permisos d\'admin',
  'pages.admin.subPage.alertMessage':'umi ui ja s\'ha publicat, us convidem a utilitzar npm run ui per iniciar l\'experiència.',
  'pages.searchTable.createForm.newRule': 'Nova regla',
  'pages.searchTable.updateForm.ruleConfig': 'Configuració de regles',
  'pages.searchTable.updateForm.basicConfig': 'Informació bàsica',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nom de la regla',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Introduïu el nom de la regla!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descripció de la regla',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Introduïu almenys cinc caràcters',
  'pages.searchTable.updateForm.ruleDesc.descRules':'Introduïu almenys cinc caràcters de descripció de la regla!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurar propietats de la regla',
  'pages.searchTable.updateForm.object': 'Objecte de monitoratge',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Plantilla de regla',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipus de regla',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Establir cicle de programació',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Hora d\'inici',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Seleccioneu l\'hora d\'inici!',
  'pages.searchTable.titleDesc': 'Descripció',
  'pages.searchTable.ruleName': 'El nom de la regla és obligatori',
  'pages.searchTable.titleCallNo': 'Nombre de crides al servei',
  'pages.searchTable.titleStatus': 'Estat',
  'pages.searchTable.nameStatus.default': 'Tancat',
  'pages.searchTable.nameStatus.running': 'En funcionament',
  'pages.searchTable.nameStatus.online': 'En línia',
  'pages.searchTable.nameStatus.abnormal': 'Anormal',
  'pages.searchTable.titleUpdatedAt': 'Última programació',
  'pages.searchTable.exception': 'Introduïu la raó de l\'excepció!',
  'pages.searchTable.titleOption': 'Operació',
  'pages.searchTable.config': 'Configuració',
  'pages.searchTable.subscribeAlert': 'Subscriure\'s a l\'alerta',
  'pages.searchTable.title': 'Taula de consultes',
  'pages.searchTable.new': 'Nou',
  'pages.searchTable.chosen': 'Seleccionat',
  'pages.searchTable.item': 'element',
  'pages.searchTable.totalServiceCalls': 'Total de crides al servei',
  'pages.searchTable.tenThousand': 'deu mil',
  'pages.searchTable.batchDeletion': 'Eliminació en lot',
  'pages.searchTable.batchApproval': 'Aprovació en lot',

  // Agents 页面相关文本
  'pages.agents.search.placeholder': 'Cercar agents intel·ligents',
  'pages.agents.create.button': 'Crear agent intel·ligent',
  'pages.agents.addDevice.button': 'Afegir dispositiu',
  'pages.agents.create.modal.title': 'Crear agent intel·ligent',
  'pages.agents.create.modal.nameLabel': 'Nom de l\'agent intel·ligent',
  'pages.agents.create.modal.placeholder': 'Introduïu el nom de l\'agent intel·ligent',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Timbre de veu del personatge',
  'pages.agents.card.languageModel': 'Model de llenguatge',
  'pages.agents.card.lastChat': 'Última conversa',
  'pages.agents.card.conversationId': 'ID de conversa',
  'pages.agents.card.clearConversation': 'Netejar ID de conversa',
  'pages.agents.card.clearConversation.success': 'ID de conversa netejat',
  'pages.agents.card.clearConversation.error': 'Error en netejar l\'ID de conversa',
  'pages.agents.card.configRole': 'Configurar personatge',
  'pages.agents.card.voiceRecognition': 'Reconeixement de veu',
  'pages.agents.card.voiceRecognition.developing': 'Funcionalitat en desenvolupament, espereu-ho aviat',
  'pages.agents.card.historyDialog': 'Historial de diàlegs',
  'pages.agents.card.manageDevice': 'Gestionar dispositiu',
  'pages.agents.card.addDevice': 'Afegir dispositiu',
  'pages.agents.loading': 'Carregant llista d\'agents intel·ligents...',
  'pages.agents.reload': 'Tornar a carregar',
  'pages.agents.empty.title': 'Sense agents intel·ligents',
  'pages.agents.empty.createFirst': 'Crear el primer agent intel·ligent',
  'pages.agents.delete.title': 'Confirmar eliminació de l\'agent intel·ligent',
  'pages.agents.delete.content': 'Després d\'eliminar l\'agent intel·ligent, tota la configuració relacionada (incloent-hi els registres de conversa relacionats amb el dispositiu) no es podrà recuperar. Confirmar eliminació?',
  'pages.agents.delete.confirm': 'Confirmar eliminació',
  'pages.agents.fetch.error': 'Error en obtenir la llista d\'agents intel·ligents',
  'pages.agents.network.error': 'Error de xarxa, torneu-ho a provar més tard',
  'pages.agents.speed.patient': 'Patient',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Ràpid',
  'pages.agents.lastChat.none': 'Cap',
  'pages.agents.language.chinese': 'Xinès',
  'pages.agents.loading.tts.error': 'Error en carregar el timbre TTS',
  'pages.agents.loading.llm.error': 'Error en carregar el proveïdor LLM',
  'pages.agents.sort.id': 'Ordenar per ID',
  'pages.agents.sort.updatedAt': 'Ordenar per última modificació',
  'pages.agents.sort.lastConversationAt': 'Ordenar per última conversa',

  // Register 页面相关文本
  'pages.register.title': 'Registre',
  'pages.register.form.title': 'Registrar nou compte',
  'pages.register.submit': 'Registrar',
  'pages.register.username.placeholder': 'Introduïu el nom d\'usuari',
  'pages.register.username.required': 'Introduïu el nom d\'usuari!',
  'pages.register.username.min': 'El nom d\'usuari ha de tenir almenys 4 caràcters',
  'pages.register.email.placeholder': 'Introduïu el correu electrònic',
  'pages.register.email.required': 'Introduïu el correu electrònic!',
  'pages.register.email.invalid': 'Introduïu una adreça de correu electrònic vàlida!',
  'pages.register.password.placeholder': 'Introduïu la contrasenya',
  'pages.register.password.required': 'Introduïu la contrasenya!',
  'pages.register.password.min': 'La contrasenya ha de tenir almenys 6 caràcters',
  'pages.register.password.pattern': 'La contrasenya ha de contenir majúscules, minúscules i números',
  'pages.register.confirmPassword.placeholder': 'Confirmeu la contrasenya',
  'pages.register.confirmPassword.required': 'Confirmeu la contrasenya!',
  'pages.register.confirmPassword.min': 'La contrasenya ha de tenir almenys 6 caràcters',
  'pages.register.error.passwordMismatch': 'Les contrasenyes introduïdes no coincideixen',
  'pages.register.error.registerFailed': 'Registre fallit, torneu-ho a provar!',
  'pages.register.success': 'Registre exitós!',

  // Login 页面相关文本
  'pages.login.title': 'Consola de gestió d\'Anime AI Chat',
  'pages.login.actionIcons.notImplemented': 'Encara no implementat, espereu-ho aviat',
  'pages.login.mobile.captchaError': 'Codi de verificació incorrecte',
  'pages.login.captcha.success': 'Codi de verificació obtingut amb èxit! El codi de verificació és: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Contacteu amb l\'administrador',
  'pages.login.mobile.notAvailable': 'Aquesta funcionalitat encara no està disponible, utilitzeu inici de sessió amb compte i contrasenya',

  // AgentSetting 页面相关文本
  'pages.agentSetting.title': 'Configurar personatge',
  'pages.agentSetting.back': 'Tornar',
  'pages.agentSetting.roleTemplate.title': 'Plantilla de personatge',
  'pages.agentSetting.roleTemplate.label': 'Plantilla',
  'pages.agentSetting.template.taiwanGirlfriend': 'Xicota taiwanesa',
  'pages.agentSetting.template.potato': 'Patatet',
  'pages.agentSetting.template.englishTutor': 'Tutor d\'anglès',
  'pages.agentSetting.template.curiousBoy': 'Nen curiós',
  'pages.agentSetting.template.puppyLeader': 'Capità dels gossets',
  'pages.agentSetting.basicConfig.title': 'Configuració bàsica',
  'pages.agentSetting.assistantName.label': 'Sobrenom de l\'assistent',
  'pages.agentSetting.assistantName.placeholder': 'Introduïu el sobrenom de l\'assistent',
  'pages.agentSetting.assistantName.required': 'Introduïu el sobrenom de l\'assistent',
  'pages.agentSetting.dialogLanguage.label': 'Idioma del diàleg',
  'pages.agentSetting.dialogLanguage.placeholder': 'Seleccioneu l\'idioma del diàleg',
  'pages.agentSetting.voiceType.label': 'Timbre de veu del personatge',
  'pages.agentSetting.voiceType.placeholder': 'Seleccioneu el timbre de veu del personatge',
  'pages.agentSetting.roleDescription.title': 'Descripció del personatge',
  'pages.agentSetting.roleDescription.label': 'Descripció del personatge',
  'pages.agentSetting.roleDescription.placeholder': 'Introduïu la descripció del personatge',
  'pages.agentSetting.roleDescription.required': 'Introduïu la descripció del personatge',
  'pages.agentSetting.languageModel.title': 'Model de llenguatge',
  'pages.agentSetting.languageModel.label': 'Model de llenguatge',
  'pages.agentSetting.languageModel.placeholder': 'Seleccioneu el model de llenguatge',
  'pages.agentSetting.languageModel.tip': 'Després de canviar el model, es recomana netejar la memòria per evitar afectar l\'experiència de xat.',
  'pages.agentSetting.advancedSettings.expand': 'Expandir configuració avançada',
  'pages.agentSetting.advancedSettings.collapse': 'Contraure configuració avançada',
  'pages.agentSetting.recognitionSpeed.label': 'Velocitat de reconeixement de veu',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Seleccioneu la velocitat de reconeixement',
  'pages.agentSetting.speechSpeed.label': 'Velocitat de parla del personatge',
  'pages.agentSetting.speechSpeed.placeholder': 'Seleccioneu la velocitat de parla',
  'pages.agentSetting.pitchValue.label': 'Volum del personatge',
  'pages.agentSetting.button.reset': 'Reinicialitzar',
  'pages.agentSetting.button.save': 'Desar',
  'pages.agentSetting.save.success': 'Desat amb èxit',
  'pages.agentSetting.save.error': 'Error en desar',
  'pages.agentSetting.save.missingId': 'Falta l\'id de l\'agent, no es pot desar',
  'pages.agentSetting.load.tts.error': 'Error en carregar el timbre TTS',
  'pages.agentSetting.speed.slow': 'Lent',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Ràpid',
  'pages.agentSetting.speed.patient': 'Patient',
  'pages.agentSetting.language.chinese': 'Mandarí',
  'pages.agentSetting.language.english': 'Anglès',
  'pages.agentSetting.language.spanish': 'Castellà',
  'pages.agentSetting.language.french': 'Francès',
  'pages.agentSetting.language.german': 'Alemany',
  'pages.agentSetting.language.japanese': 'Japonès',
  'pages.agentSetting.language.korean': 'Coreà',
  'pages.agentSetting.language.portuguese': 'Portuguès',
  'pages.agentSetting.language.arabic': 'Àrab',
  'pages.agentSetting.language.russian': 'Rus',
  'pages.agentSetting.language.italian': 'Italià',
  'pages.agentSetting.language.turkish': 'Turc',
  'pages.agentSetting.language.polish': 'Polonès',
  'pages.agentSetting.language.catalan': 'Català',
  'pages.agentSetting.mcp.modal.title': 'Punt d\'accés MCP',
  'pages.agentSetting.mcp.modal.statusLabel': 'Estat del punt d\'accés',
  'pages.agentSetting.mcp.modal.online': 'En línia',
  'pages.agentSetting.mcp.modal.disconnected': 'Desconnectat',
  'pages.agentSetting.mcp.modal.unknown': 'Desconnectat',
  'pages.agentSetting.mcp.modal.refresh': 'Actualitzar',
  'pages.agentSetting.mcp.modal.enabledServices': 'Serveis habilitats',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Adreça del punt d\'accés',
  'pages.agentSetting.mcp.modal.endpointDesc': 'A continuació es mostra l\'adreça del punt d\'accés MCP de l\'agent intel·ligent.',
  'pages.agentSetting.mcp.modal.docLink': 'Veure documentació d\'ús del punt d\'accés',
  'pages.agentSetting.mcp.modal.noEndpoint': 'Cap punt d\'accés disponible',
  'pages.agentSetting.mcp.modal.hide': 'Ocultar',
  'pages.agentSetting.mcp.modal.show': 'Mostrar',
  'pages.agentSetting.mcp.modal.copied': 'Copiat',
  'pages.agentSetting.mcp.modal.copy': 'Copiar',
  'pages.agentSetting.mcp.title': 'Configuració MCP',
  'pages.agentSetting.mcp.officialServices': 'Serveis oficials',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Seleccioneu serveis oficials',
  'pages.agentSetting.mcp.services.weather': 'Temps',
  'pages.agentSetting.mcp.services.joke': 'Acudits',
  'pages.agentSetting.mcp.services.music': 'Música',
  'pages.agentSetting.mcp.services.news': 'Notícies',
  'pages.agentSetting.mcp.customService': 'Servei personalitzat',
  'pages.agentSetting.mcp.error.missingId': 'Falta l\'id de l\'agent, no es pot obtenir el punt d\'accés',
  'pages.agentSetting.mcp.error.noEndpoint': 'No es pot obtenir el punt d\'accés del servidor',
  'pages.agentSetting.mcp.error.fetchFailed': 'Error en obtenir el punt d\'accés',
'pages.agentSetting.mcp.button.getEndpoint': 'Obtenir punt d\'accés MCP',

  // Memory settings
  'pages.agentSetting.memory.title': 'Memòria a curt termini',
  'pages.agentSetting.memory.type.label': 'Tipus de memòria',
  'pages.agentSetting.memory.type.none': 'Sense memòria',
  'pages.agentSetting.memory.type.shortTerm': 'Memòria a curt termini',
  'pages.agentSetting.memory.current.label.short': 'Memòria actual',
  'pages.agentSetting.memory.current.help': 'Regenerada dopo cada conversa',
  'pages.agentSetting.memory.clear': 'Esborrar memòria',
  'pages.agentSetting.memory.clear.tip': 'Memòria marcada per esborrar, feu clic a desar per aplicar',
  'pages.agentSetting.memory.content.label': 'Contingut de la memòria',
  'pages.agentSetting.memory.content.placeholder': 'Obtenir el contingut més recent de la memòria a curt termini de l\'agent',
  'pages.agentSetting.memory.content.editPlaceholder': 'Si us plau, introduïu el contingut de la memòria',
  'pages.agentSetting.memory.edit': 'Editar memòria',
  'pages.agentSetting.memory.edit.success': 'Memòria actualitzada, si us plau deseu per aplicar',
  'pages.agentSetting.memory.edit.save': 'Desar canvis',
  'pages.agentSetting.memory.edit.cancel': 'Cancel·lar',

  // DeviceManagement 页面相关文本
  'pages.devices.title': 'Gestionar dispositius',
  'pages.devices.breadcrumb.agents': 'Agents intel·ligents',
  'pages.devices.breadcrumb.devices': 'Gestionar dispositius',
  'pages.devices.button.addDevice': 'Afegir dispositiu',
  'pages.devices.warning.noAgentId': 'No s\'ha especificat agentId, no es pot obtenir la llista de dispositius',
  'pages.devices.device.unnamed': 'Dispositiu sense nom',
  'pages.devices.device.macAddress': 'Adreça Mac',
  'pages.devices.device.lastActive': 'Última conversa',
  'pages.devices.device.firmwareVersion': 'Versió del firmware',
  'pages.devices.device.otaUpgrade': 'Actualització OTA',
  'pages.devices.device.noData': 'Sense dades',
  'pages.devices.copy.success': 'Adreça MAC copiada',
  'pages.devices.unbind.title': 'Confirmar desvinculació del dispositiu',
  'pages.devices.unbind.content': 'Un cop desvinculat el dispositiu, no es pot recuperar. Per utilitzar-lo de nou cal tornar-lo a vincular. Confirmar desvinculació?',
  'pages.devices.unbind.confirm': 'Confirmar desvinculació',
  'pages.devices.unbind.cancel': 'Cancel·lar',
  'pages.devices.unbind.success': 'Dispositiu desvinculat',
  'pages.devices.unbind.error': 'Error en la desvinculació',
  'pages.devices.ota.enabled': 'Actualització OTA habilitada',
  'pages.devices.ota.disabled': 'Actualització OTA deshabilitada',

  // HistoryDialogs 页面相关文本
  'pages.historyDialogs.title': 'Historial de diàlegs',
  'pages.historyDialogs.breadcrumb.agents': 'Agents intel·ligents',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'Historial de diàlegs',
  'pages.historyDialogs.empty.title': 'No hi ha cap diàleg seleccionat',
  'pages.historyDialogs.empty.description': 'Seleccioneu un diàleg',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Detall de la conversa',
  'pages.historyDialogs.selectConversation': 'Seleccioneu una conversa',
  'pages.historyDialogs.delete.title': 'Eliminar diàleg',
  'pages.historyDialogs.delete.content': 'Un cop eliminat no es pot recuperar, confirmeu l\'operació.',
  'pages.historyDialogs.delete.confirm': 'Confirmar eliminació',
  'pages.historyDialogs.delete.cancel': 'Cancel·lar',
  'pages.historyDialogs.message.delete.confirm': 'Segur que voleu eliminar aquest missatge? Un cop eliminat no es pot recuperar.',
  'pages.historyDialogs.detail.title': 'Detall de la conversa',

  'pages.historyDialogs.agent.label': 'Agent intel·ligent:',
  'pages.historyDialogs.user.label': 'Usuari:',
  'pages.historyDialogs.loading': 'Carregant...',
  'pages.historyDialogs.error.loadFailed': 'Error en carregar la llista de diàlegs',
  'pages.historyDialogs.error.deleteFailed': 'Error en eliminar la sessió',
  'pages.historyDialogs.success.deleteSuccess': 'Diàleg eliminat amb èxit',

  // MessageList 页面相关文本
  'pages.messageList.empty': 'Sense missatges',
  'pages.messageList.user': 'Usuari',
  'pages.messageList.ai': 'IA',

  // Settings 页面相关文本
  'pages.settings.basicInfo.title': 'Informació bàsica',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Canviar avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar actualitzat',
  'pages.settings.avatar.updateFailed': 'Error en actualitzar l\'avatar',
  'pages.settings.registerTime.label': 'Data de registre:',
  'pages.settings.email.label': 'Correu electrònic:',
  'pages.settings.email.unbind': 'No vinculat',
  'pages.settings.email.bind': 'Vincular correu electrònic',
  'pages.settings.email.change': 'Modificar correu electrònic vinculat',
  'pages.settings.email.modal.title': 'Vincular correu electrònic',
  'pages.settings.email.modal.changeTitle': 'Modificar correu electrònic vinculat',
  'pages.settings.email.form.label': 'Correu electrònic',
  'pages.settings.email.form.required': 'Introduïu el correu electrònic',
  'pages.settings.email.form.invalid': 'Format del correu electrònic incorrecte',
  'pages.settings.email.bindSuccess': 'Correu electrònic vinculat amb èxit',
  'pages.settings.email.bindFailed': 'Error en la vinculació',
  'pages.settings.changePassword.title': 'Canviar contrasenya',
  'pages.settings.changePassword.button': 'Canviar contrasenya',
  'pages.settings.changePassword.modal.title': 'Canviar contrasenya',
  'pages.settings.changePassword.oldPassword.label': 'Contrasenya antiga',
  'pages.settings.changePassword.oldPassword.required': 'Introduïu la contrasenya antiga',
  'pages.settings.changePassword.newPassword.label': 'Contrasenya nova',
  'pages.settings.changePassword.newPassword.required': 'Introduïu la contrasenya nova',
  'pages.settings.changePassword.newPassword.min': 'La contrasenya nova ha de tenir almenys 6 caràcters',
  'pages.settings.changePassword.confirmPassword.label': 'Confirmar contrasenya nova',
  'pages.settings.changePassword.confirmPassword.required': 'Confirmeu la contrasenya nova',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Les contrasenyes introduïdes no coincideixen',
  'pages.settings.changePassword.success': 'Contrasenya canviada amb èxit',
  'pages.settings.changePassword.failed': 'Error en canviar la contrasenya',
  'pages.settings.deleteAccount.title': 'Eliminar compte',
  'pages.settings.deleteAccount.button': 'Eliminar compte',
  'pages.settings.deleteAccount.confirm.title': 'Confirmar eliminació del compte?',
  'pages.settings.deleteAccount.confirm.content': 'Aquesta operació no es pot desfer, segur que voleu eliminar el compte?',
  'pages.settings.deleteAccount.confirm.ok': 'Eliminar',
  'pages.settings.deleteAccount.confirm.cancel': 'Cancel·lar',
  'pages.settings.deleteAccount.success': 'Compte eliminat',
  'pages.settings.deleteAccount.failed': 'Error en l\'eliminació',
  'pages.settings.profile.fetchFailed': 'Error en obtenir la informació de l\'usuari',
  'pages.settings.form.submit': 'Enviar',
  'pages.settings.password.title': 'Configuració de contrasenya',
  'pages.settings.basicInfo.username': 'Nom d\'usuari',
  'pages.settings.basicInfo.nickname': 'Sobrenom',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Editar sobrenom',
  'pages.settings.basicInfo.editNicknameTitle': 'Modificar sobrenom',
  'pages.settings.basicInfo.newNicknameLabel': 'Nou sobrenom',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Sobrenom modificat amb èxit',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Desar',
  'pages.settings.deleteAccount.confirmTitle': 'Confirmació d\'eliminació del compte',
  'pages.settings.deleteAccount.confirmContent': 'Un cop eliminat el compte, totes les vostres dades seran eliminades permanentment i no es podran recuperar, i ja no podreu utilitzar aquest compte per iniciar sessió. Actueu amb precaució!',
  'pages.settings.deleteAccount.cancel': 'Cancel·lar',
  'pages.settings.deleteAccount.confirm': 'Confirmar eliminació',

  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Nombre d\'usuaris',
  'pages.admin.dashboard.deviceCount': 'Nombre de dispositius',
  'pages.admin.dashboard.agentCount': 'Nombre d\'agents intel·ligents',
  'pages.admin.dashboard.onlineUsers': 'Usuaris en línia',
  'pages.admin.dashboard.sessionDevices': 'Usuaris en conversa',
  'pages.admin.dashboard.memoryUsage': 'Ús de memòria',
  'pages.admin.dashboard.cpuUsage': 'Ús de CPU',
  'pages.admin.dashboard.fetchError': 'Error en obtenir les dades',
  'pages.admin.dashboard.networkError': 'Error de xarxa',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Nom d\'usuari',
  'pages.admin.user.email': 'Correu electrònic',
  'pages.admin.user.status': 'Estat',
  'pages.admin.user.status.all': 'Tots',
  'pages.admin.user.status.disabled': 'Deshabilitat',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Quota diària utilitzada',
  'pages.admin.user.quotaTotal': 'Quota diària total',
  'pages.admin.user.createdAt': 'Data de creació',
  'pages.admin.user.operations': 'Operacions',
  'pages.admin.user.edit': 'Editar',
  'pages.admin.user.detail': 'Detalls',
  'pages.admin.user.editModal.title': 'Editar usuari',
  'pages.admin.user.status.label': 'Estat de l\'usuari',
  'pages.admin.user.status.enable': 'Habilitar',
  'pages.admin.user.status.disable': 'Deshabilitar',
  'pages.admin.user.quotaUsed.label': 'Quota utilitzada avui',
  'pages.admin.user.quotaTotal.label': 'Quota diària total',
  'pages.admin.user.email.label': 'Correu electrònic',
  'pages.admin.user.save.success': 'Desat amb èxit',
  'pages.admin.user.save.failed': 'Error en desar',
  'pages.admin.user.list.title': 'Llista d\'usuaris',

  // Admin Model Providers
  'pages.admin.providers.title': 'Gestió de proveïdors de models',
  'pages.admin.providers.total': 'Total de {total} proveïdors',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Afegir nou proveïdor',
  'pages.admin.providers.search.placeholder': 'Cercar nom del proveïdor, punt final o model...',
  'pages.admin.providers.filter.all': 'Tots els tipus',
  'pages.admin.providers.filter.asr': 'ASR - Reconeixement de veu',
  'pages.admin.providers.filter.tts': 'TTS - Síntesi de veu',
  'pages.admin.providers.filter.llm': 'LLM - Model de llenguatge gran',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Model de llenguatge visual',
  'pages.admin.providers.empty.noProviders': 'Encara no hi ha cap proveïdor',
  'pages.admin.providers.empty.noMatches': 'No s\'han trobat proveïdors coincidents',
  'pages.admin.providers.empty.addFirst': 'Feu clic al botó de dalt per afegir el vostre primer proveïdor de models',
  'pages.admin.providers.empty.adjustFilters': 'Intenteu ajustar les condicions de cerca o els filtres',
  'pages.admin.providers.type.asr': 'ASR - Reconeixement de veu',
  'pages.admin.providers.type.tts': 'TTS - Síntesi de veu',
  'pages.admin.providers.type.llm': 'LLM - Model de llenguatge gran',
  'pages.admin.providers.type.vlllm': 'VLLLM - Model de llenguatge visual',
  'pages.admin.providers.success.created': 'Proveïdor afegit amb èxit!',
  'pages.admin.providers.success.updated': 'Proveïdor actualitzat amb èxit!',
  'pages.admin.providers.success.deleted': 'Proveïdor eliminat amb èxit!',
  'pages.admin.providers.success.statusToggled': 'Estat canviat amb èxit!',
  'pages.admin.providers.error.createFailed': 'Error en afegir el proveïdor, torneu-ho a provar',
  'pages.admin.providers.error.updateFailed': 'Error en actualitzar el proveïdor, torneu-ho a provar',
  'pages.admin.providers.error.deleteFailed': 'Error en eliminar el proveïdor, torneu-ho a provar',
  'pages.admin.providers.error.testFailed': 'Test de connexió fallit, reviseu la xarxa o la configuració',
  'pages.admin.providers.error.toggleFailed': 'Error en canviar l\'estat, torneu-ho a provar',
  'pages.admin.providers.error.loadFailed': 'Error en carregar la llista de proveïdors, actualitzeu la pàgina i torneu-ho a provar',

  // Admin Settings
  'pages.admin.settings.title': 'Configuració del sistema',
  'pages.admin.settings.asr.label': 'Servei ASR',
  'pages.admin.settings.asr.placeholder': 'Seleccioneu el servei ASR',
  'pages.admin.settings.tts.label': 'Servei TTS',
  'pages.admin.settings.tts.placeholder': 'Seleccioneu el servei TTS',
  'pages.admin.settings.llm.label': 'Servei LLM',
  'pages.admin.settings.llm.placeholder': 'Seleccioneu el servei LLM',
  'pages.admin.settings.vlllm.label': 'Servei VLLLM',
  'pages.admin.settings.vlllm.placeholder': 'Seleccioneu el servei VLLLM',
  'pages.admin.settings.prompt.label': 'Configuració de consigna',
  'pages.admin.settings.prompt.placeholder': 'Introduïu la consigna del sistema...',
  'pages.admin.settings.quickReply.label': 'Paraules de resposta ràpida',
  'pages.admin.settings.quickReply.placeholder': 'Introduïu noves paraules de resposta ràpida',
  'pages.admin.settings.quickReply.add': 'Afegir',
  'pages.admin.settings.deleteAudio.label': 'Eliminar àudio',
  'pages.admin.settings.deleteAudio.enabled': 'Habilitat',
  'pages.admin.settings.deleteAudio.disabled': 'Deshabilitat',
  'pages.admin.settings.usePrivateConfig': 'Utilitzar configuració privada',
  'pages.admin.settings.save': 'Desar configuració',
  'pages.admin.settings.saving': 'Desant...',
  'pages.admin.settings.reset': 'Reinicialitzar',
  'pages.admin.settings.success.saved': 'Configuració desada amb èxit!',
  'pages.admin.settings.error.saveFailed': 'Error en desar la configuració, torneu-ho a provar',
  'pages.admin.settings.error.loadFailed': 'Error en carregar la configuració, actualitzeu la pàgina i torneu-ho a provar',

  // Add Device Dialog
  'pages.addDevice.modal.title': 'Afegir dispositiu',
  'pages.addDevice.verificationCode.label': 'Codi de verificació:',
  'pages.addDevice.verificationCode.placeholder': 'Introduïu el codi de verificació de 6 dígits que reprodueix el dispositiu',
  'pages.addDevice.verificationCode.required': 'Introduïu el codi de verificació de 6 dígits',
  'pages.addDevice.verificationCode.error': 'Introduïu el codi de verificació de 6 dígits',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Editar proveïdor',
  'pages.admin.providerModal.add.title': 'Afegir nou proveïdor',
  'pages.admin.providerModal.name.label': 'Nom del proveïdor *',
  'pages.admin.providerModal.name.placeholder': 'Per exemple: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Introduïu el nom del proveïdor',
  'pages.admin.providerModal.type.label': 'Categoria de servei *',
  'pages.admin.providerModal.subType.label': 'Tipus específic *',
  'pages.admin.providerModal.subType.required': 'Seleccioneu el tipus específic',
  'pages.admin.providerModal.config.title': 'Informació de configuració',
  'pages.admin.providerModal.api.url.label': 'Adreça API *',
  'pages.admin.providerModal.api.url.required': 'Introduïu l\'adreça API',
  'pages.admin.providerModal.model.name.label': 'Nom del model *',
  'pages.admin.providerModal.model.name.required': 'Introduïu el nom del model',
  'pages.admin.providerModal.api.key.label': 'Clau API *',
  'pages.admin.providerModal.api.key.required': 'Introduïu la clau API',
  'pages.admin.providerModal.temperature.label': 'Temperatura (0-2)',
  'pages.admin.providerModal.temperature.error': 'El valor de temperatura ha d\'estar entre 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Nombre màxim de tokens',
  'pages.admin.providerModal.maxTokens.error': 'El nombre màxim de tokens ha d\'estar entre 1-32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'ID d\'aplicació *',
  'pages.admin.providerModal.appid.placeholder': 'ID d\'aplicació Doubao',
  'pages.admin.providerModal.appid.required': 'Introduïu l\'ID d\'aplicació',
  'pages.admin.providerModal.accessToken.label': 'Token d\'accés *',
  'pages.admin.providerModal.accessToken.placeholder': 'Token d\'accés',
  'pages.admin.providerModal.accessToken.required': 'Introduïu el token d\'accés',
  'pages.admin.providerModal.cluster.label': 'Clúster',
  'pages.admin.providerModal.grpc.host.label': 'Host gRPC *',
  'pages.admin.providerModal.grpc.host.required': 'Introduïu l\'adreça de l\'host gRPC',
  'pages.admin.providerModal.grpc.port.label': 'Port gRPC *',
  'pages.admin.providerModal.grpc.port.required': 'Introduïu el port gRPC',
  'pages.admin.providerModal.gosherpa.model.label': 'Nom del model *',
  'pages.admin.providerModal.gosherpa.model.placeholder': 'Nom del model GoSherpa',
  'pages.admin.providerModal.gosherpa.model.required': 'Introduïu el nom del model',
  'pages.admin.providerModal.voice.label': 'Timbre *',
  'pages.admin.providerModal.voice.required': 'Introduïu el tipus de veu',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.placeholder': 'Token Doubao',
  'pages.admin.providerModal.token.required': 'Introduïu el token',
  'pages.admin.providerModal.websocket.label': 'Adreça WebSocket *',
  'pages.admin.providerModal.websocket.required': 'Introduïu l\'adreça WebSocket',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'Clau API *',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'Clau API SiliconFlow',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Introduïu la clau API',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'Adreça API',
  'pages.admin.providerModal.manage.voices': 'Gestionar timbres',
  'pages.admin.providerModal.manageVoices': 'Gestionar timbres',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS no necessita configuració addicional',
  'pages.admin.providerModal.submit.error': 'Error en l\'enviament, torneu-ho a provar',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Actiu',
  'pages.admin.providerCard.status.inactive': 'Inactiu',
  'pages.admin.providerCard.status.error': 'Error',
  'pages.admin.providerCard.status.unknown': 'Desconegut',
  'pages.admin.providerCard.warning.readonly.test': 'Permisos de només lectura, no es pot provar el proveïdor',
  'pages.admin.providerCard.warning.readonly.delete': 'Permisos de només lectura, no es pot eliminar el proveïdor',
  'pages.admin.providerCard.warning.readonly.edit': 'Permisos de només lectura, no es pot editar el proveïdor',
  'pages.admin.providerCard.warning.readonly.toggle': 'Permisos de només lectura, no es pot canviar l\'estat',
  'pages.admin.providerCard.button.disable': 'Deshabilitar',
  'pages.admin.providerCard.button.enable': 'Habilitar',
  'pages.admin.providerCard.button.testing': 'Provant...',
  'pages.admin.providerCard.button.test': 'Provar',
  'pages.admin.providerCard.button.edit': 'Editar',
  'pages.admin.providerCard.button.delete': 'Eliminar',
  'pages.admin.providerCard.delete.title': 'Segur que voleu eliminar aquest element?',
  'pages.admin.providerCard.delete.content': 'Un cop eliminat no es pot recuperar, confirmeu l\'operació.',
  'pages.admin.providerCard.config.type': 'Tipus',
  'pages.admin.providerCard.config.apiUrl': 'Adreça API',
  'pages.admin.providerCard.config.model': 'Model',
  'pages.admin.providerCard.config.apiKey': 'Clau API',
  'pages.admin.providerCard.config.temperature': 'Temperatura',
  'pages.admin.providerCard.config.maxTokens': 'Màxim tokens',
  'pages.admin.providerCard.config.appid': 'ID d\'aplicació',
  'pages.admin.providerCard.config.cluster': 'Clúster',
  'pages.admin.providerCard.config.accessToken': 'Token d\'accés',
  'pages.admin.providerCard.config.grpcHost': 'Host gRPC',
  'pages.admin.providerCard.config.grpcPort': 'Port gRPC',
  'pages.admin.providerCard.config.voice': 'Veu',
  'pages.admin.providerCard.config.format': 'Format',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Directori de sortida',
  'pages.admin.providerCard.voices.supported': 'Veus compatibles',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Test fallit',

  // 白名单
  'pages.admin.whiteList.inputMac': 'Introduïu l\'adreça mac',
  'pages.admin.whiteList.batchAdd': 'Afegir en lot',
  'pages.admin.whiteList.add': 'Afegir',
  'pages.admin.whiteList.list.title': 'Llista d\'adreces mac',
  'pages.admin.whiteList.selectCsvTip': 'Seleccioneu un fitxer csv',
  'pages.admin.whiteList.uploadSuccess': 'Pujada exitosa',
  'pages.admin.whiteList.uploadFailed': 'Error en la pujada',
  'pages.admin.whiteList.invalidMac': 'Introduïu una adreça mac vàlida',

  // 运维管理 OpsManage
  'pages.admin.ops.service.title': 'Gestió de serveis',
  'pages.admin.ops.upload.button': 'Pujar fitxer de servei',
  'pages.admin.ops.upload.success': 'Fitxer de servei pujat amb èxit',
  'pages.admin.ops.upload.error': 'Error en pujar el fitxer de servei',
  'pages.admin.ops.restart.button': 'Reiniciar servei',
  'pages.admin.ops.restart.confirmTitle': 'Operació delicada: Confirmar reinici del servei?',
  'pages.admin.ops.restart.desc': 'Reiniciar el servei desconnectarà totes les connexions actuals i el servei no estarà disponible temporalment.',
  'pages.admin.ops.restart.warn': 'Aquesta operació només tancarà el procés del servei actual. Assegureu-vos que el servidor té configurat un procés de control o script de reinici automàtic, altrament el servei no es podrà recuperar automàticament!',
  'pages.admin.ops.restart.ok': 'Confirmar reinici',
  'pages.admin.ops.restart.cancel': 'Cancel·lar',
  'pages.admin.ops.restart.success': 'Instrucció de reinici del servei enviada',
  'pages.admin.ops.restart.error': 'Error en reiniciar el servei',
  'pages.admin.ops.log.title': 'Navegació i descàrrega de logs',
  'pages.admin.ops.web.upload.button': 'Pujar web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip pujat amb èxit',
  'pages.admin.ops.web.upload.error': 'Error en pujar web.zip',
  'pages.admin.ops.web.upload.onlyzip': 'Només es permeten fitxers zip',
  'pages.admin.ops.web.update.button': 'Actualitzar directori web',
  'pages.admin.ops.web.update.success': 'Instrucció d\'actualització del directori web enviada',
  'pages.admin.ops.web.update.error': 'Error en actualitzar el directori web',
  'pages.admin.ops.web.upload.onlywebzip': 'Només es permet pujar fitxers amb nom web.zip',

  // 录音管理 RecorderManage
  'pages.admin.recorder.title': 'Gestió d\'enregistraments del dispositiu',
  'pages.admin.recorder.inputDeviceId': 'Introduïu l\'ID del dispositiu',
  'pages.admin.recorder.inputPlaceholder': 'Introduïu l\'ID del dispositiu',
  'pages.admin.recorder.search': 'Consultar',
  'pages.admin.recorder.list.title': 'Llista d\'enregistraments',
  'pages.admin.recorder.fetchSuccess': 'Registres d\'enregistrament obtinguts amb èxit',
  'pages.admin.recorder.fetchError': 'Error en obtenir la llista d\'enregistraments',
  'pages.admin.recorder.empty': 'Sense dades d\'enregistrament, introduïu l\'ID del dispositiu per consultar',
  'pages.admin.recorder.totalCount': 'Informació estadística',
  'pages.admin.recorder.conversationId': 'ID de conversa',

  'pages.agentSetting.roleTemplate.empty': 'Sense plantilles, reviseu role_template.json',
  'pages.admin.providerModal.save': 'Desar',
  'pages.admin.providerModal.copyAsNew': 'Copiar com a nou proveïdor',

  // Botons i operacions comuns
  'pages.common.cancel': 'Cancel·lar',

  // Configuració del sistema
  'pages.admin.systemConfig.roleName': 'Nom del rol',
  'pages.admin.systemConfig.roleDesc': 'Descripció del rol',
  'pages.admin.systemConfig.enabled': 'Estat activat',
  'pages.admin.systemConfig.featureName': 'Nom de la funcionalitat',
  'pages.admin.systemConfig.featureDesc': 'Descripció de la funcionalitat',
  'pages.admin.systemConfig.exitCommand': 'Comanda de sortida',
  'pages.admin.systemConfig.mcpName': 'Nom MCP',
  'pages.admin.systemConfig.newNameOptional': 'Nou nom (opcional)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Utilitzar codi del dispositiu',
  'pages.admin.systemConfig.quickReply': 'Resposta ràpida',
  'pages.admin.systemConfig.shortTermMemory': 'Memòria de curt termini',
  'pages.admin.systemConfig.saveUserAudio': 'Desar fitxers dàudio de lusuari',
  'pages.admin.systemConfig.enableWhiteList': 'Activar llista blanca',
  'pages.admin.systemConfig.speakerDetect': 'Reconeixement de veu',
  'pages.admin.systemConfig.recorderManagerEnable': 'Activar gestió de gravador',
  'pages.admin.systemConfig.voiceCloneEnable': 'Activar clonatge de veu',
  'pages.admin.systemConfig.flattenedChatHistory': 'Historial de xat aplanat',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Longitud de lhistorial de diàleg',
  'pages.admin.systemConfig.userTotalQuota': 'Quota total de lusuari',
  'pages.admin.systemConfig.dailyClearQuota': 'Quota diària',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Comprovar mode del dispositiu immediatament',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Rol dobservador predeterminat per a nous usuaris',
  'pages.admin.systemConfig.status': 'Estat',
  'pages.admin.systemConfig.port': 'Port',
  'pages.admin.systemConfig.udpShowPort': 'Mostrar port',
  'pages.admin.systemConfig.accessToken': 'Token daccés',
  'pages.admin.systemConfig.activateText': 'Text dactivació',
  'pages.admin.systemConfig.logLevel': 'Nivell de registre',
  'pages.admin.systemConfig.logDir': 'Directori de registre',
  'pages.admin.systemConfig.logFileName': 'Nom del fitxer de registre',

  // Clonatge de veu
  'pages.console.voiceClone.name': 'Nom',
  'pages.console.voiceClone.provider': 'Proveïdor',
  'pages.console.voiceClone.mode': 'Mode',
  'pages.console.voiceClone.record': 'Gravar',
  'pages.console.voiceClone.upload': 'Pujar',

  // Reconeixement de veu
  'pages.console.speakers.name': 'Nom',
  'pages.console.speakers.mode': 'Mode',
  'pages.console.speakers.record': 'Gravar',
  'pages.console.speakers.upload': 'Pujar',

  // Configuració de la pàgina
  'pages.console.settings.email': 'Correu electrònic',
  'pages.console.settings.oldPassword': 'Contrasenya antiga',
  'pages.console.settings.newPassword': 'Nova contrasenya',
  'pages.console.settings.confirmNewPassword': 'Confirmar nova contrasenya',

  // Proveïdor VLLM
  'pages.providers.vllm.maxPixels': 'Nombre màxim de píxels',

  'pages.unbindDevice.cardTitle': 'Desvincular dispositiu',
  'pages.whiteList.cardTitle': 'Gestió de la llista blanca',
  'pages.admin.ops.logViewer.previewTitle': 'Previsualització de log',
  'pages.admin.ops.logViewer.fileName': 'Nom del fitxer:',
  'pages.admin.ops.logViewer.lineCount': 'Nombre de línies:',
  'pages.admin.ops.logViewer.previewBtn': 'Previsualitzar',
  'pages.admin.ops.logViewer.noContent': 'No hi ha contingut',
  'pages.admin.deviceManage': 'Gestió de dispositius',
  'pages.systemConfig.quickReply': 'Resposta ràpida',
  'pages.systemConfig.useShortTermMemory': 'Memòria a curt termini',
  'pages.systemConfig.useShortTermMemory.desc': 'Quan s\'activa, el sistema utilitza un mecanisme de memòria a curt termini i l\'actualitza després de cada ronda de diàleg. Quan està desactivat, no s\'utilitza la memòria a curt termini.',
  'pages.admin.providerModal.model.label': 'Model *',
  'pages.admin.providerModal.model.placeholder': 'Introdueix el nom del model',
  'pages.admin.providerModal.model.required': 'Introdueix el nom del model',
  'pages.admin.providerModal.security.title': 'Configuració de seguretat',
  'pages.admin.providerModal.grpc.addr.label': 'Adreça gRPC (host:port) *',
  'pages.admin.providerModal.grpc.addr.required': 'Introdueix l\'adreça gRPC (host:port)',
  'pages.admin.settings.voiceCloneEnable': 'Activa la clonació de veu',
  'pages.contractDevice.cardTitle': 'Gestió de dispositius contractuels',
  'pages.contractDevice.mac': 'Adreça MAC',
  'pages.contractDevice.protocolType': 'Tipus de protocol',
  'pages.contractDevice.status': 'Estat',
  'pages.contractDevice.expireTime': 'Temps d\'expiració',
  'pages.contractDevice.updateTime': 'Hora d\'actualització',
  'pages.contractDevice.operations': 'Operacions',
  'pages.contractDevice.edit': 'Editar',
  'pages.contractDevice.delete': 'Eliminar',
  'pages.contractDevice.deleteConfirm': 'Confirmar eliminació',
  'pages.contractDevice.addTitle': 'Afegir dispositiu contractual',
  'pages.contractDevice.batchAddTitle': 'Afegir per lots',
  'pages.contractDevice.editTitle': 'Editar dispositiu contractual',
  'pages.contractDevice.listTitle': 'Llista de dispositius contractuels',
  'pages.contractDevice.add': 'Afegir',
  'pages.contractDevice.batchAdd': 'Afegir per lots',
  'pages.contractDevice.selectCsvTip': 'Selecciona un fitxer CSV',
  'pages.contractDevice.uploadSuccess': 'Pujada amb èxit',
  'pages.contractDevice.macRequired': 'Introdueix l\'adreça MAC',
  'pages.contractDevice.protocolTypeRequired': 'Selecciona el tipus de protocol',
  'pages.contractDevice.statusRequired': 'Selecciona l\'estat',
  'pages.contractDevice.expireTimeRequired': 'Selecciona el temps d\'expiració',
};